var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSecondaryChecked = function SvgSecondaryChecked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#5DD927",
    d: "M23.125 15a8.125 8.125 0 1 0-16.25 0 8.125 8.125 0 0 0 16.25 0M5 15a10 10 0 1 1 20 0 10 10 0 0 1-20 0m10-3.75a3.75 3.75 0 1 1 0 7.5 3.75 3.75 0 0 1 0-7.5"
  })));
};
export default SvgSecondaryChecked;